import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CreateAgentModalComponent } from './create-agent-modal/create-agent-modal.component';

interface Agent {
  id: string;
  name: string;
  type: string;
  apps: string[];
  lastRun: Date;
  status: 'active' | 'inactive';
}

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, NgbModule],
})
export class AgentsComponent implements OnInit {
  agents: Agent[] = [];
  searchTerm = '';
  selectedApp = 'Any app';
  sortField = 'dateCreated';
  sortDirection = 'desc';
  viewMode: 'grid' | 'list' = 'grid';

  constructor(private modalService: NgbModal) {}

  ngOnInit() {
    // TODO: Replace with actual API call
    this.loadAgents();
  }

  loadAgents() {
    // Mock data for now
    this.agents = [
      {
        id: '1',
        name: 'Daily Offline Asset Report',
        type: 'scheduled',
        apps: ['Email', 'Slack'],
        lastRun: new Date(),
        status: 'active',
      },
      {
        id: '2',
        name: 'Building Health',
        type: 'trigger',
        apps: ['Email'],
        lastRun: new Date(),
        status: 'active',
      },
    ];
  }

  openNewAgentModal() {
    const modalRef = this.modalService.open(CreateAgentModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });

    modalRef.result.then(
      result => {
        if (result) {
          this.loadAgents();
        }
      },
      () => {}
    );
  }

  filterAgents() {
    return this.agents.filter(agent => {
      const matchesSearch = agent.name
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase());
      const matchesApp =
        this.selectedApp === 'Any app' || agent.apps.includes(this.selectedApp);
      return matchesSearch && matchesApp;
    });
  }

  sortAgents(agents: Agent[]) {
    return agents.sort((a, b) => {
      if (this.sortField === 'dateCreated') {
        return this.sortDirection === 'desc'
          ? b.lastRun.getTime() - a.lastRun.getTime()
          : a.lastRun.getTime() - b.lastRun.getTime();
      }
      return 0;
    });
  }

  toggleViewMode() {
    this.viewMode = this.viewMode === 'grid' ? 'list' : 'grid';
  }
}
